/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputDateRangeArrow/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputDateRangeArrow({
  children,
  viewPath = "/DesignSystem/TysiaInputDateRange/Trigger/TysiaInputDateRangeArrow",
  disabled,
  marginLeft,
  tabIndex = -1,
  paddingLeft,
  paddingRight,
  onFocus,
  isShowingOptions,
  onBlur,
  size
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 size="small"
 type="ghost"
 height={16}
 disabled={disabled}
 marginLeft={marginLeft}
 tabIndex={tabIndex}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 onClick={isShowingOptions ? onBlur : onFocus}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={size === "small" ? "12px" : "20px"}
 height={size === "small" ? "12px" : "20px"}
 fill={disabled ? dtColorsNeutral400 : dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}